// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iq1P","colMin":"styles_colMin__CxNAX"};